import { render, staticRenderFns } from "./AppModalHeader.vue?vue&type=template&id=841f6924&scoped=true&"
import script from "./AppModalHeader.vue?vue&type=script&lang=ts&"
export * from "./AppModalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AppModalHeader.vue?vue&type=style&index=0&id=841f6924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841f6924",
  null
  
)

export default component.exports